import { render, staticRenderFns } from "./PageViolations.vue?vue&type=template&id=e5b4659c&"
import script from "./PageViolations.vue?vue&type=script&lang=ts&"
export * from "./PageViolations.vue?vue&type=script&lang=ts&"
import style0 from "./PageViolations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports